<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Consulta de declarações emitidas.</span>
                <br />
                <span class="navigation">Relatório > Consulta Declarações</span>
              </h4>
            </div>
          </div>
        </div>

        <div class="card-body">
          <error-list :erros="erros" />

          <div class="row">
            <div class="col-md-2 col-lg-2 mb-1">
              <label for="compIni">Competência Inicial: *</label>
            </div>
            <div class="col-md-2 col-lg-2 mb-1">
              <label for="compFim">Competência Final: *</label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <InputMask
                  v-model="compIni"
                  id="compIni"
                  mask="9999/99"
                  placeholder="Competência Inicial"
                />
              </span>
            </div>

            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <InputMask
                  v-model="compFim"
                  id="compFim"
                  mask="9999/99"
                  placeholder="Competência Final"
                />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 col-lg-2 mb-3">
              <Button
                class="btn btn-primary"
                type="button"
                icon="pi pi-print"
                label="Imprimir"
                title="Imprimir"
                :disabled="loading"
                @click="imprimirConsultaDeclaracao()"
              ></Button>
            </div>
          </div>

          <div style="height:45vh"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import ReportService from "../services/report.service";

export default {
  name: "RelatorioDeclaracao",

  components: {},
  data() {
    return {
      erros: [],
      loading: null,
      compIni: "",
      compFim: "",
      competenciaLimite: null,
      currentUser: null
    };
  },
   mounted() {
    document.getElementById("compIni").focus();
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.competenciaLimite = new Date();
    this.competenciaLimite.setMonth(this.competenciaLimite.getMonth());
    this.carregarCompetenciaAtual();
  },
  methods: {
    carregarCompetenciaAtual() {
      let ano = this.competenciaLimite.getFullYear();
      let mes = this.competenciaLimite.getMonth();
      mes = mes + 1;

      this.compIni = ano + "/" + mes.toString().padStart(2, '0');
      this.compFim = ano + "/" + mes.toString().padStart(2, '0');
    },
    imprimirConsultaDeclaracao() {
      var msg = null;
      if (!this.compIni) {
        msg = "É necessário informar a competência inicial!";
      } else if (!this.compFim) {
        msg = "É necessário informar a competência final!";
      }
      if (!msg) {
        this.processando(true);
        let anoIni = this.compIni.substring(0, 4);
        let anoFim = this.compFim.substring(0, 4);
        let mesIni = parseInt(this.compIni.substring(5, 7));
        let mesFim = parseInt(this.compFim.substring(5, 7));
        ReportService.imprimir("ConsultaDeclaracao", [
          {
            param: "ID_CONTRIBUINTE",
            string: this.currentUser.contribuinte.idContribuinte
          },
          {
            param: "ANO_INICIAL",
            string: anoIni
          },
          {
            param: "ANO_FINAL",
            string: anoFim
          },
          {
            param: "MES_INICIAL",
            string: mesIni
          },
          {
            param: "MES_FINAL",
            string: mesFim
          },
          {
            param: "COMPETENCIA_FINAL",
            string: this.compFim
          },
          {
            param: "COMPETENCIA_INICIAL",
            string: this.compIni
          }
        ])
          .then(
            () => {},
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>